import { useState, useCallback } from 'react';
import sharepointSyncService, {
  SharePointSite,
  DocumentLibrary,
} from '../services/sharepoint-sync.service';

export const useSharePoint = () => {
  const [sites, setSites] = useState<SharePointSite[]>([]);
  const [libraries, setLibraries] = useState<DocumentLibrary[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  /**
   * Fetch all SharePoint sites
   */
  const fetchSites = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const sitesList = await sharepointSyncService.getSites();
      setSites(sitesList);
    } catch (err: any) {
      setError(err.message);
      console.error('Error fetching sites:', err);
    } finally {
      setLoading(false);
    }
  }, []);

  /**
   * Fetch document libraries for a specific site
   */
  const fetchLibraries = useCallback(async (siteId: string) => {
    setLoading(true);
    setError(null);
    try {
      const librariesList = await sharepointSyncService.getLibraries(siteId);
      setLibraries(librariesList);
    } catch (err: any) {
      setError(err.message);
      console.error('Error fetching libraries:', err);
    } finally {
      setLoading(false);
    }
  }, []);

  /**
   * Clear error message
   */
  const clearError = useCallback(() => {
    setError(null);
  }, []);

  return {
    // State
    sites,
    libraries,
    loading,
    error,

    // Actions
    fetchSites,
    fetchLibraries,
    clearError,
  };
};
